module.exports = __webpack_public_path__ + "static/img/PrestationEnfant2.38b674f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationEnfant2.jpeg
// module id = cHLK
// module chunks = 1